import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Usb, Bluetooth, LayoutGrid } from "lucide-react";
import Logo from "../Logo";

export default function TopBar({ links = [] }) {
  const { pathname } = useLocation();
  const [conn, setConn] = useState("usb");
  return (
    <header className="no-print sticky top-0 z-50 glass border-b border-slate-200/80" data-testid="shop-topbar">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" data-testid="topbar-hub-link"><Logo /></Link>
        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => {
            const active = pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                className={`px-3.5 py-2 rounded-lg text-sm font-medium transition-colors ${
                  active ? "bg-slate-900 text-white" : "text-slate-600 hover:text-sky-700 hover:bg-sky-50"
                }`}
                data-testid={`topbar-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>
        <div className="flex items-center gap-2">
          <div className="hidden sm:flex items-center rounded-full border border-slate-200 bg-white p-0.5" data-testid="topbar-connectivity">
            <button
              onClick={() => setConn("usb")}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${conn === "usb" ? "bg-sky-600 text-white" : "text-slate-500"}`}
              data-testid="conn-usb-btn"
            >
              <Usb className="h-3.5 w-3.5" /> USB
            </button>
            <button
              onClick={() => setConn("ble")}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold transition-colors ${conn === "ble" ? "bg-sky-600 text-white" : "text-slate-500"}`}
              data-testid="conn-ble-btn"
            >
              <Bluetooth className="h-3.5 w-3.5" /> BLE
            </button>
          </div>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-700 hover:text-sky-700 px-3 py-2 rounded-lg hover:bg-sky-50"
            data-testid="topbar-projects-btn"
          >
            <LayoutGrid className="h-4 w-4" /> Projects
          </Link>
        </div>
      </div>
    </header>
  );
}
